var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('div',{staticClass:"question-text",style:({
      fontFamily: _vm.poll.jsStyle.answerFont.name,
      color: _vm.poll.jsStyle.questionColor
    })},[_vm._v(_vm._s(_vm.question.texts[_vm.lang]))])])}
var staticRenderFns = []

export { render, staticRenderFns }